import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwPillItem, DwUiConfigRegistryService } from '@devwareapps/devware-cap';
import { SchoolFeatures } from '../../../schools/models/school-features.model';
import { SchoolRepositoryService } from '../../../schools/services/school-repository.service';


@DwComponent({
  key: 'CousrsePage',
  name: 'Course Page',
  componentType: DwComponentType.pageComponent,
  isGlobal: true
})
@Component({
  selector: 'app-course-page',
  templateUrl: './course-page.component.html',
  styleUrls: ['./course-page.component.scss']
})
export class CoursePageComponent implements OnInit {

  schoolFeatures: SchoolFeatures;

  myCoursesTab : DwPillItem = {
    display: 'My Courses',
    value: 'my-courses',
    iconClass: 'fa fa-book',
    tooltip: 'My Courses'
  };

  marketplaceTab : DwPillItem = {
    display: 'Marketplace',
    value: 'marketplace',
    iconClass: 'fa fa-cart-plus',
    tooltip: 'Marketplace to buy courses'
  };
  
  tabs: any[];

  currentTab: string;

  showTabs = true;

  constructor(private schoolRepositoryService: SchoolRepositoryService, private dwUiConfigRegistraty: DwUiConfigRegistryService) { }

  ngOnInit(): void {
    this.tabs = [this.myCoursesTab, this.marketplaceTab];

    this.currentTab = this.myCoursesTab.value;

    this.schoolRepositoryService.getSchoolFeatures()
      .subscribe((features) => {  
        this.schoolFeatures = features;

        this.schoolFeatures.IsMarketplaceEnabled
      });

      DwUiConfigRegistryService.logRegistrations();
  }

  setPillsTab(tabKey: string) {

  }

}
